import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ExternalLink, RefreshCw, IdCard } from "lucide-react";

/**
 * ABDMABHARegistrationModal — one-tap redirect to the ABDM's own
 * ABHA-creation flow. We deliberately DO NOT re-implement ABHA
 * onboarding here; the government portal is the authoritative source
 * and any spoofed clone would violate the NHA guidelines.
 */
const ABHA_URL = "https://abha.abdm.gov.in/abha/v3/register";

export default function ABDMABHARegistrationModal({ open, onClose, onRefresh }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="abha-registration-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <IdCard size={18} className="text-blue-600" />
            Create your ABHA ID
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3 text-sm text-slate-700">
          <p>
            ABHA (Ayushman Bharat Health Account) is your unified 14-digit
            health id issued by the Government of India.
          </p>
          <p className="text-xs text-slate-500">
            Registration is free and takes about 2 minutes. Once created,
            paste it into UpchaarQ to link your health records.
          </p>
          <ol className="text-xs list-decimal ml-4 space-y-1 text-slate-600">
            <li>Open the official portal below.</li>
            <li>Use Aadhaar / driving licence to verify.</li>
            <li>Return here and tap <strong>Refresh</strong> to link.</li>
          </ol>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Close</Button>
          {onRefresh && (
            <Button variant="outline" onClick={onRefresh}
                    data-testid="abha-registration-refresh">
              <RefreshCw size={14} className="mr-1" /> Refresh
            </Button>
          )}
          <Button asChild className="bg-blue-600 hover:bg-blue-700 text-white"
                  data-testid="abha-registration-open">
            <a href={ABHA_URL} target="_blank" rel="noopener noreferrer">
              <ExternalLink size={14} className="mr-1" /> Open ABHA Registration
            </a>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
